import Track from './track';
import BaseAnnotationStore from './BaseAnnotationStore';
export default class TrackStore extends BaseAnnotationStore {
    add(frame, defaultType, afterId, overrideTrackId, meta = undefined) {
        const track = new Track(overrideTrackId, {
            begin: frame,
            end: frame,
            confidencePairs: [[defaultType, 1]],
            meta,
        });
        this.insert(track, { afterId });
        this.markChangesPending({ action: 'upsert', track, cameraName: this.cameraName });
        return track;
    }
    getUserAttributeList() {
        let userList = new Set();
        this.annotationMap.forEach((item) => {
            userList = new Set([...userList, ...item.getUserAttributeList()]);
        });
        return userList;
    }
}
